import { useCallback, useEffect, useRef, useState } from "react";
import { useNotificacaoAlerta } from "../../../../Context/NotificacaoAlerta";
import DropdownMenuIcon from "../../DropdownMenuIcon";
import NoficacoesUsuario from "../NoficacoesUsuario";

export default function NovasNotificacoes() {
    const {
        lstAtividadesAtendimentos: atividadesAtendimentos,
        ultimasNotificacoes,
        ultimasTransferencias,
        updateNotificacoes: update,
    } = useNotificacaoAlerta();

    const TabNotificacao = useRef<HTMLLIElement>(null);

    const executeScroll2 = () => TabNotificacao.current?.scrollIntoView();

    const [pulse, setPulse] = useState(true);

    const updateNotificacoes = useCallback(() => {
        update("notificacoes");
    }, [update]);

    function QtdNotificacao() {
        if (ultimasNotificacoes?.NR_TOTAL_NOTIFICACOES! > 99) {
            return "99+";
        } else {
            return ultimasNotificacoes?.NR_TOTAL_NOTIFICACOES ?? "-";
        }
    }

    useEffect(() => {
        if (
            ultimasNotificacoes &&
            ultimasNotificacoes?.NR_TOTAL_NOTIFICACOES > 0 &&
            atividadesAtendimentos?.some(
                (atv) => atv.NR_ATENDIMENTOS_ABERTOS > 0
            ) &&
            ultimasTransferencias &&
            ultimasTransferencias?.NR_NOTIFICACOES > 0
        )
            setPulse(true);
    }, [atividadesAtendimentos, ultimasNotificacoes, ultimasTransferencias]);

    return (
        <DropdownMenuIcon
            onOpen={() => setPulse(false)}
            pulse={pulse}
            icon={
                <>
                    <i className="far fa-bell"></i>
                    <span className="position-absolute badge badge-notification p-0">
                        {QtdNotificacao()}
                    </span>
                </>
            }
        >
            <div
                className={`d-flex justify-content-center flex-column pt-2 rounded-top`}
                style={{ backgroundColor: `var(--capys)` }}
            >
                <div
                    className="w-100"
                    style={{ maxWidth: "350px", overflow: "hidden" }}
                >
                    <ul
                        className="justify-content-center nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-transparent-white flex-nowrap mt-3 px-8"
                        role="tablist"
                    >
                        <li className="nav-item" ref={TabNotificacao}>
                            <span
                                className="nav-link show active"
                                data-toggle="tab"
                                onClick={executeScroll2}
                            >
                                Notificações{" "}
                                <span className="badge badge-light ml-2">
                                    {ultimasNotificacoes?.NR_TOTAL_NOTIFICACOES ??
                                        "-"}
                                </span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="tab-content menu-notificacao-container y-scroll">
                <div
                    id="topbar_notifications_events"
                    role="tabpanel"
                    onClick={executeScroll2}
                >
                    <NoficacoesUsuario
                        lstNotificacoes={ultimasNotificacoes?.lstNotificacoes}
                        updateNotificacoes={updateNotificacoes}
                    />
                </div>
            </div>
        </DropdownMenuIcon>
    );
}
